<div class="container" data-cy="table-manage-overlay">
  <span class="title">Управление таблицей</span>

  <prlw-icon
    name="three-dots-active"
    class="close-modal-button"
    data-cy="manage-overlay-close-modal"
    (click)="close()"
  ></prlw-icon>

  <div class="item-wrapper">
    <span
      class="item"
      [attr.data-cy]="'manage-overlay-item-' + column.name"
      *ngFor="let column of columns"
      [class.item--static]="column.isStatic"
      (click)="toggleColumn(column.id)"
    >
      <span
        class="toggle"
        [class.toggle--active]="column.isVisible"
        [class.toggle--static]="column.isStatic"
      >
        <prlw-icon
          *ngIf="column.isStatic || column.isVisible"
          name="check-mark"
          class="toggle__icon"
        ></prlw-icon>
      </span>
      <span class="item__name">{{ column.name }}</span>
    </span>
  </div>
</div>
